<template>

    <div class="nl" v-show="isFirstRefreshDone">

        <newsletters-v2-header v-show="!isTuto"
                               :category="category"
                               :subscriptions="subscriptionsFromSelectedMailbox"
                               :maxSubscriptions="maxSubscriptions"
                               @updateCategory="updateCategory"
        ></newsletters-v2-header>

        <search v-show="showSearch"
                :list="treatedNewsletters"
                :searchValue="searchValue"
        ></search>

        <div class="body">

            <multi-scan-completed v-show="showMultiScan"></multi-scan-completed>

            <tuto v-if="isTuto" @close="initPage"></tuto>

            <empty v-else-if="showEmpty"></empty>

            <unavailable v-else-if="showUnavailable"></unavailable>

            <no-mailbox-selected v-else-if="noMailboxSelectedButNewslettersWaiting"></no-mailbox-selected>

            <list v-else-if="showList"
                  :list="treatedNewsletters"
                  :category="category"
                  @action="action"
            ></list>

            <cards v-else-if="showCards"
                   ref="CARDS"
                   :subscriptions="treatedNewsletters"
                   @action="action"
                   @share="share"
            ></cards>

            <senders v-show="showSenders"></senders>

            <modal-tuto-action ref="modalTutoAction"
                               @close="closeModal"
            ></modal-tuto-action>

            <modal-share ref="MS"></modal-share>

            <modal-rating ref="MR"></modal-rating>


        </div>

    </div>

</template>

<script>
import Vuex from 'vuex'

import ENUM from '../assets/ENUM'

import ActionsBatch from '../modules/actionsBatch'
import Tag from '../modules/tag'
import UserFlow from '../modules/userFlow'

import Cards from '../components/newsletters-v2/Cards'
import Empty from '../components/newsletters-v2/Empty'
import List from '../components/newsletters-v2/List'
import ModalRating from '../components/modal/ModalRating'
import ModalShare from '../components/modal/ModalShare'
import ModalTutoAction from '../components/modal/ModalTutoAction'
import MultiScanCompleted from '../components/newsletters-v2/MultiScanCompleted'
import NewslettersV2Header from '../components/newsletters-v2/Header'
import NoMailboxSelected from '../components/newsletters-v2/NoMailboxSelected'
import Search from '../components/newsletters-v2/Search'
import Senders from '../components/newsletters-v2/Senders'
import Unavailable from '../components/newsletters-v2/Unavailable'
import Tuto from '../components/newsletters-v2/tuto/Tuto'

import Storage from '../helpers/storage'
import Subscription from '../helpers/subscription'


export default {

    name: 'newsletters-v2',

    components: {
        Cards,
        Empty,
        List,
        ModalRating,
        ModalShare,
        ModalTutoAction,
        MultiScanCompleted,
        NewslettersV2Header,
        NoMailboxSelected,
        Search,
        Senders,
        Unavailable,
        Tuto
    },

    watch: {

        newslettersPage() {

            this.updateTagPage()
        },

        fetchStatus() {
            this.checkFetchStatus()
        }
    },

    computed: {
        ...Vuex.mapGetters([
            'enoughNewsletters',
            'fetchEndNotif',
            'fetchStatus',
            'isFirstRefreshDone',
            'laterList',
            'mailboxes',
            'newsletters',
            'newslettersBus',
            'newslettersPage',
            'newslettersWaiting',
            'newslettersSearchingMode',
            'newslettersSort',
            'noMailboxSelectedButNewslettersWaiting',
            'selectedMailboxes',
            'searchValue'
        ]),

        ENUM() {
            return ENUM
        },

        isCards() {
            return this.newslettersPage === ENUM.NEWSLETTERS.PAGE.CARDS && !this.showEmpty
        },

        isList() {
            return this.newslettersPage === ENUM.NEWSLETTERS.PAGE.LIST && !this.showEmpty
        },

        isTuto() {
            return this.newslettersPage === ENUM.NEWSLETTERS.PAGE.TUTO
        },

        subscriptionsFromSelectedMailbox() {
            return this.newsletters.filter(newsletter => newsletter.email ? this.selectedMailboxes.includes(newsletter.email) : true)
        },

        categorisedSubscriptions() {
            switch (this.category) {
                case ENUM.NEWSLETTERS.CATEGORIES.ALL:
                    return this.subscriptionsFromSelectedMailbox
                case ENUM.NEWSLETTERS.CATEGORIES.SUBSCRIPTIONS:
                    return this.subscriptionsFromSelectedMailbox.filter(subscription => !Subscription.isSpoum(subscription))
                case ENUM.NEWSLETTERS.CATEGORIES.SPAMS:
                    return this.subscriptionsFromSelectedMailbox.filter(subscription => Subscription.isSpoum(subscription))
            }
        },

        filteredSubscriptions() {
            if (this.searching && this.searchValue === '') {
                return []
            } else {
                return this.searchValue
                    ? this.categorisedSubscriptions.filter(item => `${item.name} ${item.sender}`.indexOf(this.searchValue) > -1)
                    : this.categorisedSubscriptions
            }
        },

        sortedSubscriptions() {
            return this.sortArray(JSON.parse(JSON.stringify(this.filteredSubscriptions || [])))
        },

        sortedLaterList() {
            return this.sortArray(JSON.parse(JSON.stringify(this.laterList || [])))
        },

        treatedNewsletters() {
            if (this.laterList.length) {
                if (this.laterInfoCardNeeded) {
                    return [...this.sortedSubscriptions, {isLater: true}, ...this.sortedLaterList]
                } else {
                    return [...this.sortedSubscriptions, ...this.sortedLaterList]
                }
            } else {
                return this.sortedSubscriptions
            }
        },

        showEmpty() {
            return !this.isTuto
                && this.treatedNewsletters.length === 0
                && this.isFirstRefreshDone
                && !this.noMailboxSelectedButNewslettersWaiting
                && this.laterList.length === 0
        },

        showUnavailable() {
            // if no mailbox available
            return !(this.mailboxes.some(mailbox => mailbox.providerShutdown === false)) && this.isFirstRefreshDone
        },

        showList() {
            return (this.isDesktop ? true : this.newslettersSearchingMode !== ENUM.NEWSLETTERS.SEARCHING_MODE.SEARCHING) && this.isList && !this.showUnavailable
        },

        showCards() {
            return this.newslettersSearchingMode === ENUM.NEWSLETTERS.SEARCHING_MODE.UNACTIVE && this.isCards && !this.showUnavailable
        },

        showSenders() {
            return this.newslettersSearchingMode === ENUM.NEWSLETTERS.SEARCHING_MODE.SEARCHING && !this.showUnavailable
        },

        showSearch() {
            return !this.isTuto && (this.newslettersSearchingMode === ENUM.NEWSLETTERS.SEARCHING_MODE.UNACTIVE || this.newslettersSearchingMode === ENUM.NEWSLETTERS.SEARCHING_MODE.SEARCHING)
        },

        showMultiScan() {
            return this.fetchEndNotif && !this.showEmpty && this.newslettersWaiting && !this.showUnavailable
        },

        maxSubscriptions() {
            return this.subscriptionsFromSelectedMailbox
                .filter(item => item.type === ENUM.NEWSLETTERS.CARDS.SUBSCRIPTIONS).length
        }
    },

    data() {
        return {
            extras: [],
            category: '',
            searching: false,
            rating: {
                actionCount: 0,
                shownAfter: 20,
                alreadyShown: false,
                opened: false,
                hasRated: false,
                displayCount: 0
            },
            laterInfoCardNeeded: true
        }
    },

    mounted() {
        ActionsBatch.startCounter()
        this.refreshNewsletters()

        this.initPage()

        if (this.fetchStatus !== ENUM.FETCH_STATUS.INITIAL) {
            this.checkFetchStatus()
        }

    },

    methods: {

        ...Vuex.mapActions([
            'initNewsletterSort',
            'refreshNewsletters',
            'updateNewslettersPage'
        ]),

        initPage() {

            this.initNewsletterSort()

            const tutoDone = !Storage.getItem(Storage.KEYS.TUTO_NEWSLETTERS)
            if (tutoDone) {
                this.updateNewslettersPage(ENUM.NEWSLETTERS.PAGE.TUTO)
            } else {

                const savedPage = Storage.getItem(Storage.KEYS.NEWSLETTERS_PAGE)
                if (savedPage && Object.values(ENUM.NEWSLETTERS.PAGE).includes(savedPage)) {
                    this.updateNewslettersPage(savedPage)
                    Storage.removeItem(Storage.KEYS.NEWSLETTERS_PAGE)
                } else {
                    this.isDesktop
                        ? this.updateNewslettersPage(ENUM.NEWSLETTERS.PAGE.LIST)
                        : this.updateNewslettersPage(ENUM.NEWSLETTERS.PAGE.CARDS)
                }
            }

            this.updateCategory(ENUM.NEWSLETTERS.CATEGORIES.ALL)
            this.updateTagPage()
        },

        updateTagPage() {
            switch (this.newslettersPage) {
                case ENUM.NEWSLETTERS.PAGE.LIST:
                    Tag.pageViewGA(this, 'cleaning_list')
                    UserFlow.setPage(this, 'cleaning_list')
                    break
                case ENUM.NEWSLETTERS.PAGE.CARDS:
                    Tag.pageViewGA(this, 'cleaning_cards')
                    UserFlow.setPage(this, 'cleaning_cards')
                    break
            }
        },

        updateCategory(newCategory) {
            this.category = newCategory
        },

        action({enumAction, senders}) {
            this.removeSpecificSenders(senders)
            if(senders[0].isLater) {
                // it's later info card
                return
            }
            if (this.needConfirmation(enumAction)) {
                this.$refs.modalTutoAction.open(senders, enumAction)
            } else {
                const cleanedSendersLength = ActionsBatch.requestAction({enumAction, senders})
                this.updateRating(cleanedSendersLength)
            }
        },

        removeSpecificSenders(senders) {
            senders.forEach(sender => {
                if(sender.isLater) {
                    this.laterInfoCardNeeded = false
                }
            })
        },

        needConfirmation(enumAction) {
            if (this.isCards) {
                return false
            }
            switch (enumAction) {
                case ENUM.NEWSLETTERS.ACTIONS.UNSUBSCRIBES:
                    return !Storage.getItem('disableModalUnsubscribe')
                case ENUM.NEWSLETTERS.ACTIONS.DELETE:
                    return !Storage.getItem('disableModalDelete')
                case ENUM.NEWSLETTERS.ACTIONS.KEEP:
                    return !Storage.getItem('disableModalKeep')
            }
        },

        closeModal({accept, enumAction, senders}) {
            if (accept) {
                const cleanedSendersLength = ActionsBatch.requestAction({enumAction, senders})
                this.updateRating(cleanedSendersLength)
            } else if (this.isCards) {
                //refresh Cards if rollback after throw out
                this.$refs.CARDS.refresh()
            }
        },

        compare(itemA, itemB) {
            if (itemA < itemB) {
                return -1
            }
            if (itemA > itemB) {
                return 1
            }
            return 0
        },

        share() {
            this.$refs.MS.open()
        },

        updateRating(length) {

            this.rating.actionCount += length

            if (!this.rating.alreadyShown && this.rating.displayCount < 2) {
                if (!this.rating.opened) {
                    if (this.rating.actionCount >= this.rating.shownAfter) {
                        this.rating.displayCount += 1
                        this.rating.opened = true
                        this.rating.shownAfter = this.rating.actionCount + 40
                        this.$refs.MR.open()
                    }
                }
            }
        },

        checkFetchStatus() {
            if (this.fetchStatus !== ENUM.FETCH_STATUS.DONE && this.fetchStatus !== ENUM.FETCH_STATUS.PARTIAL) {
                if (this.fetchStatus === ENUM.FETCH_STATUS.PENDING && !this.enoughNewsletters) {
                    this.$router.push({path: '/fetch'})
                }
            } else {
                return true
            }
        },

        sortArray(newArray) {
            switch (this.newslettersSort) {
                case ENUM.NEWSLETTERS.SORT.MOST_OPEN:
                    return newArray.sort((itemA, itemB) => this.compare(itemB.openRate, itemA.openRate))
                case ENUM.NEWSLETTERS.SORT.LEAST_OPEN:
                    return newArray.sort((itemA, itemB) => this.compare(itemA.openRate, itemB.openRate))
                case ENUM.NEWSLETTERS.SORT.ASCENDING:
                    return newArray.sort((itemA, itemB) => this.compare(itemA.count, itemB.count))
                case ENUM.NEWSLETTERS.SORT.DESCENDING:
                    return newArray.sort((itemA, itemB) => this.compare(itemB.count, itemA.count))
                case ENUM.NEWSLETTERS.SORT.UP_TO_DATE:
                    return newArray.sort((itemA, itemB) => this.compare(new Date(itemA.lastReceivedAt).getTime(), new Date(itemB.lastReceivedAt).getTime()))
                case ENUM.NEWSLETTERS.SORT.OLDEST:
                    return newArray.sort((itemA, itemB) => this.compare(new Date(itemB.lastReceivedAt).getTime(), new Date(itemA.lastReceivedAt).getTime()))
            }
            return newArray
        }
    }
}
</script>

<style lang="scss" scoped>

.nl {
    background-color: $timberwolf;
    position: relative;

    @media screen and (min-width: $above-tablet-length) {
        background-color: $white;
    }

    .body {
        display: flex;
        flex-direction: column;
        flex: 1;
        position: relative;
    }
}

</style>
